"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[286],{

/***/ 4230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ map_AutoCompleteMap; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react-google-autocomplete/lib/usePlacesAutocompleteService.js
var usePlacesAutocompleteService = __webpack_require__(3780);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./app/component/commons/icon/SvgIcon.tsx
var SvgIcon = __webpack_require__(8377);
;// CONCATENATED MODULE: ./app/component/commons/input/InputSearch.tsx


var InputSearch = function(param) {
    var value = param.value, name = param.name, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "Input text" : _placeholder, _className = param.className, className = _className === void 0 ? "" : _className, onChange = param.onChange, onClick = param.onClick, onFocus = param.onFocus, _required = param.required, required = _required === void 0 ? false : _required, innerRef = param.innerRef, _autoComplete = param.autoComplete, autoComplete = _autoComplete === void 0 ? "on" : _autoComplete, defaultValue = param.defaultValue, autoFocus = param.autoFocus, readOnly = param.readOnly, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _zIndex = param.zIndex, zIndex = _zIndex === void 0 ? "" : _zIndex;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative ".concat(zIndex),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex absolute inset-y-0 left-0 items-center pl-3.5 md:pl-4.5 pointer-events-none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-warning-500",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* LocationBoldIcon */.Oi, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                ref: innerRef,
                id: "input-".concat(name),
                value: value,
                defaultValue: defaultValue,
                type: "text",
                className: "block py-[0.85rem] md:py-[1.6rem] pr-[6.5rem] pl-10 md:pl-12 w-full text-regular-tight placeholder:text-neutral-500 text-neutral-700 bg-white rounded-full focus:outline-none shadow-lv3",
                placeholder: placeholder,
                onChange: onChange,
                onFocus: onFocus,
                required: required,
                autoComplete: autoComplete,
                autoFocus: autoFocus,
                readOnly: readOnly || disabled
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "text-white absolute right-3.5 md:right-4.5 bottom-2 md:bottom-3 bg-primary-500 hover:bg-primary-600 focus:outline-none font-medium rounded-full text-small-tight md:text-regular-none py-2 px-4 md:py-4 md:px-8 transition duration-500 ease-in-out",
                onClick: onClick,
                children: "Search"
            })
        ]
    });
};
/* harmony default export */ var input_InputSearch = (InputSearch);

;// CONCATENATED MODULE: ./app/component/plugins/map/AutoCompleteMap.tsx







var AutoCompleteMap = function(param) {
    var currentLocation = param.currentLocation, changeLocation = param.changeLocation, searchShow = param.searchShow, inputSearchOnClick = param.inputSearchOnClick, show = param.show, _inputClassName = param.inputClassName, inputClassName = _inputClassName === void 0 ? "shadow-lv3" : _inputClassName, _searchResult = param.searchResult, searchResult = _searchResult === void 0 ? "" : _searchResult, _label = param.label, label = _label === void 0 ? "Find and Select Location" : _label, _hiddenAutocomplete = param.hiddenAutocomplete, hiddenAutocomplete = _hiddenAutocomplete === void 0 ? false : _hiddenAutocomplete, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, solo = param.solo;
    var searchRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(""), inputSearch = ref[0], setInputSearch = ref[1];
    var ref1 = (0,react.useState)(false), openSearch = ref1[0], setOpenSearch = ref1[1];
    var ref2 = (0,react.useState)(false), max = ref2[0], setMax = ref2[1];
    var params = {
        // apiKey: "",
        options: {
            input: "",
            componentRestrictions: {
                country: [
                    "us"
                ]
            }
        }
    };
    var ref3 = (0,usePlacesAutocompleteService/* default */.Z)(solo ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
        apiKey: "AIzaSyAocY3PHCXrFWuMvro_jwYfEmc7wb5mJDA"
    }) : params), placePredictions = ref3.placePredictions, getPlacePredictions = ref3.getPlacePredictions, isPlacePredictionsLoading = ref3.isPlacePredictionsLoading;
    (0,react.useEffect)(function() {
        if (searchResult) {
            setInputSearch(searchResult);
        }
    }, [
        searchResult
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_InputSearch, {
                innerRef: searchRef,
                value: inputSearch,
                name: "find",
                placeholder: label,
                onChange: function(e) {
                    var val = e.target.value;
                    if (val.length > 2) {
                        setMax(true);
                        getPlacePredictions({
                            input: val
                        });
                    } else {
                        setMax(false);
                    }
                    setOpenSearch(true);
                    setInputSearch(val);
                    searchShow("open");
                },
                onClick: inputSearchOnClick,
                onFocus: function(e) {
                    var val = e.target.value;
                    if (val.length > 2) {
                        setMax(true);
                        getPlacePredictions({
                            input: val
                        });
                    } else {
                        setMax(false);
                    }
                    setOpenSearch(true);
                    searchShow("open");
                },
                className: inputClassName,
                autoComplete: "off",
                disabled: disabled
            }),
            openSearch && show === "open" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-3.5 bg-white shadow-lv3 p-4.5 rounded-[0.875rem] flex flex-col space-y-4.5 z-30",
                    children: [
                        disabled && max && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-row space-x-2 items-center text-neutral-900 ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-neutral-400",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* LocationBoldIcon */.Oi, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col space-y-1.5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-small-tight font-medium text-neutral-900",
                                            children: "Location is Disabled"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-tiny-tight text-neutral-700",
                                            children: "Since you’re choshing max radius you will get the whole country instead"
                                        })
                                    ]
                                })
                            ]
                        }),
                        !disabled && !hiddenAutocomplete && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-row space-x-2 items-center text-neutral-900 cursor-pointer",
                                    onClick: currentLocation,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-warning-500",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* GpsBoldIcon */.kw, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-small-normal ",
                                            children: "Use your current location"
                                        })
                                    ]
                                }),
                                inputSearch && !isPlacePredictionsLoading && max && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: placePredictions.length > 0 ? placePredictions.map(function(e, key) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-row space-x-2 items-center text-neutral-900 cursor-pointer",
                                            onClick: function() {
                                                setOpenSearch(false);
                                                searchShow("close");
                                                // changeLocation?.(
                                                //   e.place_id,
                                                //   `${e.terms[0].value}, ${
                                                //     e.terms[e.terms.length - 1].value
                                                //   }`
                                                // );
                                                changeLocation === null || changeLocation === void 0 ? void 0 : changeLocation(e.place_id, e.description);
                                                setInputSearch(e.description);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-primary-200",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* LocationBoldIcon */.Oi, {})
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-col space-y-1.5",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "text-small-tight font-medium",
                                                            children: [
                                                                e.terms[0].value,
                                                                ",",
                                                                " ",
                                                                e.terms[e.terms.length - 1].value
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-tiny-tight text-neutral-700",
                                                            children: e.description
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, key);
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row space-x-2 items-center text-neutral-900",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-neutral-400",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* LocationSlashBoldIcon */.Uj, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col space-y-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-small-tight font-medium",
                                                        children: "Location Not Covered"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-tiny-tight text-neutral-700",
                                                        children: "We're truly sorry our services didn't cover that location yet"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                !max && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-row space-x-2 items-center text-neutral-900 ",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-neutral-400",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* LocationBoldIcon */.Oi, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col space-y-1.5",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-small-tight font-medium text-neutral-900",
                                                    children: "Min 3 Characters"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-tiny-tight text-neutral-700",
                                                    children: "Type at least 3 characters to find locations"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var map_AutoCompleteMap = (AutoCompleteMap);


/***/ }),

/***/ 2712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$J": function() { return /* binding */ MAP_USA; },
/* harmony export */   "D5": function() { return /* binding */ getSpesificResultGeocode; },
/* harmony export */   "JO": function() { return /* binding */ boundariesUSA; },
/* harmony export */   "JY": function() { return /* binding */ OPTIONS; },
/* harmony export */   "TW": function() { return /* binding */ createRadius; },
/* harmony export */   "V9": function() { return /* binding */ getKeyByValue; },
/* harmony export */   "Vw": function() { return /* binding */ METER; },
/* harmony export */   "_v": function() { return /* binding */ sleep; },
/* harmony export */   "gI": function() { return /* binding */ LOADER; },
/* harmony export */   "he": function() { return /* binding */ MAP_DEFAULT; },
/* harmony export */   "lC": function() { return /* binding */ USA_CENTER; },
/* harmony export */   "w6": function() { return /* binding */ getDynamicResult; }
/* harmony export */ });
/* unused harmony exports boundariesUSAOutside, MAP_ID, OPTIONS_OLD, LIBRARIES, getCity, getResultCity, getResultAddress, VERSION */
// NEW YORK DEFAULT
var MAP_DEFAULT = {
    lat: 40.7232274,
    lng: -74.001718
};
// USA CENTER
var USA_CENTER = {
    lat: 39.8097343,
    lng: -98.5556199
};
// USA BORDER LIMITS
var USA_BOUNDS = {
    north: 67.4250519739,
    south: -21.082827843,
    west: -162.1197412536,
    east: -28.3502100036
};
// PLACE ID USA
var MAP_USA = "ChIJCzYy5IS16lQRQrfeQ5K5Oxw";
var boundariesUSA = {
    strokeColor: "#3366FF",
    strokeOpacity: 1,
    strokeWeight: 1,
    fillColor: "#3366FF",
    fillOpacity: 0.4
};
var boundariesUSAOutside = {
    strokeColor: "#1A202C",
    strokeOpacity: 1,
    strokeWeight: 1,
    fillColor: "#1A202C",
    fillOpacity: 0.2
};
// MAP ID
var MAP_ID = [
    "a2af02ba90571cc7"
];
// OPTIONS GOOGLE MAP
var OPTIONS = {
    restriction: {
        latLngBounds: USA_BOUNDS,
        strictBounds: false
    },
    gestureHandling: "cooperative",
    mapId: "a2af02ba90571cc7",
    fullscreenControl: false,
    zoomControl: false,
    streetViewControl: false,
    mapTypeControl: false
};
var OPTIONS_OLD = {
    restriction: {
        latLngBounds: USA_BOUNDS,
        strictBounds: false
    },
    gestureHandling: "cooperative"
};
// CREATE RADIUS FROM WAYPOINTS
var createRadius = function(waypoints) {
    var rad = {};
    waypoints.map(function(e, key) {
        rad[key + 1] = e.toString();
    });
    return rad;
};
// LIBRARIES
var LIBRARIES = [
    "places"
];
// MILES TO METERS
var METER = 1609.344;
var getCity = function(data) {
    var city = "";
    var searching = data.filter(function(e) {
        if (e.types.includes("locality")) {
            return e;
        } else if (e.types.includes("administrative_area_level_1")) {
            return e;
        }
    });
    if (searching.length > 0) {
        city = searching[0].long_name;
    }
    return city;
};
var getResultCity = function(data, type) {
    var city = "";
    var searching = data.filter(function(e) {
        if (e.types.includes(type)) {
            return e;
        } else if (e.types.includes("locality")) {
            return e;
        } else if (e.types.includes("administrative_area_level_1")) {
            return e;
        }
    });
    if (searching.length > 0) {
        var searching2 = searching[0].address_components.filter(function(e) {
            if (e.types.includes("locality")) {
                return e;
            } else if (e.types.includes("administrative_area_level_1")) {
                return e;
            }
        });
        if (searching2.length > 0) {
            city = searching[0].formatted_address;
        }
    }
    return city;
};
var getDynamicResult = function(data, type) {
    var res = "";
    var searching2 = data.address_components.filter(function(e) {
        if (e.types.includes(type)) {
            return e;
        }
    });
    if (searching2.length > 0) {
        res = searching2[0].long_name;
    }
    return res;
};
var getResultAddress = function(data) {
    var address = "";
    if (data.length > 0) {
        address = data[0].formatted_address;
    }
    return address;
};
// VERSION OF MAP
var VERSION = "beta";
var LOADER = {
    googleMapsApiKey: "AIzaSyAocY3PHCXrFWuMvro_jwYfEmc7wb5mJDA",
    libraries: LIBRARIES,
    mapIds: MAP_ID,
    version: VERSION
};
var getKeyByValue = function(object, value) {
    return Object.keys(object).find(function(key) {
        return object[key] === value;
    });
};
var sleep = function(ms) {
    return new Promise(function(r) {
        return setTimeout(r, ms);
    });
};
var getSpesificResultGeocode = function(data) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "locality";
    var result = data.filter(function(e) {
        if (e.types.includes(type)) {
            return e;
        }
    });
    if (result.length > 0) {
        return result[0];
    }
    var result_postal_code = data.filter(function(e) {
        if (e.types.includes("postal_code")) {
            return e;
        }
    });
    if (result_postal_code.length > 0) {
        return result_postal_code[0];
    }
    var result_route = data.filter(function(e) {
        if (e.types.includes("route")) {
            return e;
        }
    });
    if (result_route.length > 0) {
        return result_route[0];
    }
    var result_country = data.filter(function(e) {
        if (e.types.includes("country")) {
            return e;
        }
    });
    if (result_country.length > 0) {
        return result_country[0];
    }
    return data[0];
};


/***/ })

}]);